export default "__VITE_ASSET__h$bVCXzX__"